import { type ReactNode } from "react";

const defaultRichTextElements = {
  p: (chunks: ReactNode) => <p>{chunks}</p>,
  b: (chunks: ReactNode) => <b>{chunks}</b>,
  u: (chunks: ReactNode) => <u>{chunks}</u>,
  ul: (chunks: ReactNode) => <ul>{chunks}</ul>,
  li: (chunks: ReactNode) => <li>{chunks}</li>,
  strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
  span: (chunks: ReactNode) => <span>{chunks}</span>,
  br: () => <br />,
};

export default defaultRichTextElements;
